
// サポート入力メッセージ処理
import { SendToCosmos, LoadToCosmos } from './SendToCosmos';
//test
//const RequestSupportSend = async (input, filtermessages, userId, mode,loginInfo,setMessages) => {
    const RequestSupportSend = async (input, mode, loginInfo, messages, requestNumber) => {
    const lastMessage = messages[messages.length - 1];

    // requestNumberが引数として渡されていない場合のみ、メッセージ履歴から抽出を試みる
    if (!requestNumber) {
        console.warn('requestNumberが渡されていません。メッセージ履歴から抽出を試みます。');
        // メッセージ履歴から受付番号を検索（最新のsupportメッセージから）
        for (let i = messages.length - 1; i >= 0; i--) {
            if (messages[i].sender === 'support') {
                const match = messages[i].text.match(/受付番号は(SU\d+)です/);
                if (match) {
                    requestNumber = match[1];
                    break;
                }
            }
        }
    }
    
    // 受付番号が見つからない場合はエラー
    if (!requestNumber) {
        console.error('受付番号が見つかりませんでした');
        return '依頼に失敗しました。<br>受付番号が見つかりません。';
    }
    
    console.log('使用する受付番号:', requestNumber);

    // webhookが存在し、オブジェクトであり、support.urlが存在するかチェック
    const webhook = (loginInfo?.webhook && typeof loginInfo.webhook === 'object' && loginInfo.webhook !== 'none')
        ? loginInfo.webhook?.support?.url
        : null;

    if (!webhook) {
        console.error('webhook URLが設定されていません', loginInfo.webhook);
        return '依頼に失敗しました。<br>Webhook URLが設定されていません。';
    }

    const header = {'Content-Type': 'application/json'};
    
    // プロンプトテンプレートから実際の値に置換
    const messageText = lastMessage.text.replace(/\$\{requestNumber\}/g, requestNumber);
    
    let message
    message = {
        attachments: [
            {
            contentType: "application/vnd.microsoft.card.hero",
            content: {
                title: "サポート依頼",
                text: messageText,
                requestNumber: requestNumber
            }
            }
        ]
    };

    const requestBody = {
        api:webhook,
        header:header, 
        message:message ,
        mode:'supportsend',
    };

    try {
        // webhook URLに情報を送信
        const response = await fetch(`${process.env.REACT_APP_CROSPRO_URL}?code=${process.env.REACT_APP_CROSPRO_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
        });

        if (response.status === 200) {
            // 依頼履歴をCosmosDBに保存（requestNumberを渡す）
            await saveRequestToCosmosDB(mode, loginInfo, lastMessage, requestNumber);
            return 'サポートに依頼しました。'
        } else {
            console.error('Webhook送信エラー:', response.status, response.statusText);
            return '依頼に失敗しました。<br>もう一度お願いします。'
        }

    } catch (error) {
        console.error('APIエラー:', error);
        return `申し訳ありません。<br>問合せエラーが発生しました。`
    }

};

// CosmosDBに依頼履歴を保存する関数
const saveRequestToCosmosDB = async (mode, loginInfo, lastMessage, requestNumber) => {
    console.log('saveRequestToCosmosDB called with:', { mode, loginInfo, lastMessage, requestNumber });

    try {
        const userId = `${loginInfo.compId}`; // 企業コードのみ

        console.log('MK0 userId:', userId);
        console.log('MK0 loginInfo.compName:', loginInfo.compName);
        console.log('MK0 loginInfo.userName:', loginInfo.userName);
        console.log('MK0 loginInfo.id:', loginInfo);
        console.log('MK0 loginInfo.userId:', loginInfo.userId);
        console.log('MK0 requestNumber:', requestNumber);
        
        // 既存のデータを取得
        const loadPayload = { 
            id: userId, 
            container: 'con-concierge-request' 
        };
        
        let existingData;
        try {
            existingData = await LoadToCosmos(loadPayload);
        } catch (error) {
            // データが存在しない場合は新規作成
            existingData = null;
        }

        // メッセージから店舗番号と店舗名を抽出
        let storeName = null;
        const storeNumberMatch = lastMessage.text.match(/店舗番号\(必須\)[:：]\s*(\d+)/);
        const storeNameMatch = lastMessage.text.match(/店舗名\(必須\)[:：]\s*([^\n]+)/);
        
        if (storeNumberMatch && storeNameMatch) {
            const storeNumber = storeNumberMatch[1];
            const storeNameText = storeNameMatch[1].trim();
            storeName = `${storeNumber} ${storeNameText}`;
            console.log('抽出した店舗情報:', storeName);
        }

        // 新しい依頼データを作成
        const requestData = {
            id: crypto.randomUUID(),
            content: lastMessage.text,
            status: '依頼中',
            timestamp: Date.now(),
            requestNumber: requestNumber, // requestNumber（受付番号）を使用
            storeId: loginInfo.userId, // 店舗ID（企業コード-店舗コード）を追加
            storeName: storeName, // 店舗番号と店舗名を結合した情報
            unreadFor: ['admin'], // 新規依頼はAdmin権限が未読対象
            createdBy: loginInfo.authorityId // 作成者の権限を記録
        };

        console.log('MK1 requestData:', requestData);
        console.log('MK2 loginInfo.id:', existingData);

        let storesData;
        
        if (existingData && existingData.item && existingData.item.messages) {
            // 既存データがある場合
            storesData = existingData.item.messages;
            console.log('MK3 existing storesData:', storesData);
        } else {
            // 新規作成の場合
            storesData = {};
            console.log('MK4 new storesData created');
        }

        // 店舗IDが存在しない場合は新規作成
        if (!storesData[loginInfo.userId]) {
            console.log('MK5 creating new store entry for:', loginInfo.userId);
            storesData[loginInfo.userId] = {
                userName: loginInfo.userName,
                messages: [
                    {
                        category: "support",
                        messages: []
                    },
                    {
                        category: "sendbak",
                        messages: []
                    }
                ]
            };
        }

        console.log('MK6 storesData after store creation:', storesData);

        // 該当するカテゴリに依頼を追加または更新
        const categoryName = mode === 'sendbak' ? 'sendbak' : 'support';
        console.log('MK7 categoryName:', categoryName);
        
        const categoryIndex = storesData[loginInfo.userId].messages.findIndex(cat => cat.category === categoryName);
        console.log('MK8 categoryIndex:', categoryIndex);
        
        if (categoryIndex !== -1) {
            // 既存の依頼でidが一致するものを探す
            const existingRequestIndex = storesData[loginInfo.userId].messages[categoryIndex].messages.findIndex(
                req => req.id === requestData.id
            );
            
            if (existingRequestIndex !== -1) {
                // idが一致した場合は更新
                storesData[loginInfo.userId].messages[categoryIndex].messages[existingRequestIndex] = requestData;
                console.log('MK9 updated existing request with id:', requestData.id);
            } else {
                // idが一致しない場合は新規追加
                storesData[loginInfo.userId].messages[categoryIndex].messages.push(requestData);
                console.log('MK9 added new request with id:', requestData.id);
            }
        }

        // CosmosDBに保存
        const savePayload = {
            id: userId,
            compName: loginInfo.compName,
            messages: storesData,
            container: "con-concierge-request"
        };
        
        console.log('MK10 Final savePayload:', JSON.stringify(savePayload, null, 2));
        await SendToCosmos(savePayload);
        console.log('依頼履歴をCosmosDBに保存しました');
        
    } catch (error) {
        console.error('依頼履歴の保存エラー:', error);
        throw error;
    }
};

// CosmosDBの依頼ステータスを更新する関数
const updateRequestStatus = async (request, newStatus, loginInfo, actionNumber = null) => {
    try {
        //const userId = `${loginInfo.compId}`; // 企業コードのみ
        const userId = `${request.companyId}`; // 企業コードのみ
        
        // 既存のデータを取得
        const loadPayload = { 
            id: userId, 
            container: 'con-concierge-request' 
        };
        
        const existingData = await LoadToCosmos(loadPayload);
        if (!existingData || !existingData.item || !existingData.item.messages) {
            throw new Error('依頼データが見つかりません');
        }

        let updated = false;
        const storesData = existingData.item.messages;

        // 全ての店舗、カテゴリを検索して該当する依頼を更新
        Object.keys(storesData).forEach(storeId => {
            storesData[storeId].messages.forEach(category => {
                const requestIndex = category.messages.findIndex(req => req.id === request.id);
                if (requestIndex !== -1) {
                    category.messages[requestIndex].status = newStatus;
                    category.messages[requestIndex].updatedAt = Date.now();
                    
                    // アクション番号が提供された場合は更新
                    if (actionNumber !== null) {
                        category.messages[requestIndex].actionNumber = actionNumber;
                        console.log(`依頼 ${userId} のアクション番号を ${actionNumber} に更新しました`);
                    }
                    
                    updated = true;
                    console.log(`依頼 ${userId} のステータスを ${newStatus} に更新しました`);
                }
            });
        });

        if (!updated) {
            throw new Error(`依頼ID ${userId} が見つかりません`);
        }

        // CosmosDBに保存
        const savePayload = {
            id: userId,
            compName:request.companyName,
            messages: storesData,
            container: "con-concierge-request"
        };
        
        await SendToCosmos(savePayload);
        console.log('依頼ステータスの更新をCosmosDBに保存しました');
        
        return true;
        
    } catch (error) {
        console.error('依頼ステータス更新エラー:', error);
        throw error;
    }
};

export { updateRequestStatus };
export default RequestSupportSend;

